<template>
    <div class="flex flex-col min-h-full flex-grow" :class="`bg-${local.body.backgroundColor}`">
        <nav class="shadow-sm" :class="`bg-${local.navigation.backgroundColor}`">
            <div class="mx-auto px-4 sm:px-6 lg:px-8">
                <div class="flex justify-between h-16">
                    <div class="flex">
                        <div class="flex-shrink-0 flex items-center">
                            <a href="/" class="text-white text-xs">
                                <img class="inline-block h-10 rounded-md"
                                     :class="local.logo.shadow ? 'shadow-sm' : ''" :src="board.logo_url">
                                <h1 class="hidden">{{ board.name }}</h1>
                            </a>
                        </div>
<!--                        <div class="hidden sm:ml-6 sm:flex">-->
<!--                            <div class="relative inline-block text-left inline-flex">-->
<!--                                <div class="inline-flex items-center">-->
<!--                                    <a href="#"-->
<!--                                       :class="`text-${local.body.linkColor}`"-->
<!--                                       class="inline-flex items-center px-3 py-2 text-sm font-medium leading-5 rounded-md transition duration-150 ease-in-out">-->
<!--                                        {{ 'Categories' }}-->
<!--                                        <svg class="-mr-1 ml-2 h-5 w-5" viewBox="0 0 20 20" fill="currentColor">-->
<!--                                            <path fill-rule="evenodd"-->
<!--                                                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"-->
<!--                                                  clip-rule="evenodd"/>-->
<!--                                        </svg>-->
<!--                                    </a>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
                    </div>
<!--                    <div class="flex-1 flex items-center justify-center px-2 lg:ml-6 lg:justify-end">-->
<!--                        <div class="max-w-lg w-full lg:max-w-xs">-->
<!--                            <div class="relative">-->
<!--                                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">-->
<!--                                    <svg class="h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">-->
<!--                                        <path fill-rule="evenodd"-->
<!--                                              d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"-->
<!--                                              clip-rule="evenodd"/>-->
<!--                                    </svg>-->
<!--                                </div>-->
<!--                                <label for="searchInput" class="sr-only">Search</label>-->
<!--                                <input-->
<!--                                    id="searchInput"-->
<!--                                    :class="`border-${this.primaryColor()}-300 placeholder-${primaryColor()}-500 focus:placeholder-${primaryColor()}-400 focus:border-${primaryColor()}-300 focus:ring-${primaryColor()}`"-->
<!--                                    class="block w-full pl-10 pr-3 py-2 border rounded-md leading-5 bg-white  focus:outline-none sm:text-sm transition duration-150 ease-in-out"-->
<!--                                    placeholder="Search" type="search"/>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
                    <div class="hidden sm:ml-6 sm:flex sm:items-center">
                    <span class="inline-flex rounded-md shadow-sm">
                      <button type="button"
                              :class="`bg-${local.primaryButton.backgroundColor}`"
                              class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white transition ease-in-out duration-150">
                        <a href="#">Post a job</a>
                      </button>
                    </span>
                    </div>
                </div>
            </div>
        </nav>
        <div id="hero"
             :class="`bg-${local.hero.backgroundColor} from-${local.navigation.backgroundColor} to-${local.hero.backgroundColor}`"
             class="text-center px-8 py-8 h-48 relative bg-gradient-to-r">
            <h2 class="mt-8 text-4xl tracking-tight font-bold leading-8 sm:leading-12"
                :class="`text-${local.hero.textColor}`">{{ local.hero.text || board.short_description }}</h2>
        </div>
        <div class="my-8 mx-6">
            <div class="bg-white shadow overflow-hidden sm:rounded-md">
                <ul>
                    <li>
                        <a href="#"
                           class="block hover:bg-gray-100 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out">
                            <div class="px-4 py-6 sm:px-6">
                                <div class="flex flex items-center justify-between">
                                    <div class="flex-1">
                                        <div class="flex flex-col sm:flex-row sm:items-center justify-between">
                                            <div class="flex flex-col sm:flex-row">
                                                <div class="leading-5 truncate">
                                                    <span :class="`text-${local.body.linkColor}`"
                                                          class="text-normal font-medium">Growth Hacker</span>
                                                </div>
                                                <div class="leading-5 truncate sm:ml-1">
                                                    <span class="text-gray-800">at NoCode Academy</span>
                                                </div>
                                            </div>
                                            <div class="mt-2 sm:mt-0 md:ml-2 flex-shrink-0 flex">
                                                <span
                                                    class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full
                                                    bg-green-100 text-green-800">Full-time</span>

                                                <span
                                                    class="ml-3 px-2 inline-flex text-xs leading-5 font-semibold
                                                    rounded-full bg-pink-100 text-pink-800">Remote OK</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </li>
                    <li>
                        <a href="#"
                           class="block hover:bg-gray-100 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out">
                            <div class="px-4 py-6 sm:px-6">
                                <div class="flex flex items-center justify-between">
                                    <div class="flex-1">
                                        <div class="flex flex-col sm:flex-row sm:items-center justify-between">
                                            <div class="flex flex-col sm:flex-row">
                                                <div class="leading-5 truncate">
                                                    <span :class="`text-${local.body.linkColor}`"
                                                          class="text-normal font-medium">Social Media Manager</span>
                                                </div>
                                                <div class="leading-5 truncate sm:ml-1">
                                                    <span class="text-gray-800">at SodaJens</span>
                                                </div>
                                            </div>
                                            <div class="mt-2 sm:mt-0 md:ml-2 flex-shrink-0 flex">
                                                <span
                                                    class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full
                                                    bg-green-100 text-green-800">Full-time</span>

                                                <span
                                                    class="ml-3 px-2 inline-flex text-xs leading-5 font-semibold
                                                    rounded-full bg-pink-100 text-pink-800">Remote OK</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div id="footer" :class="`bg-${local.footer.backgroundColor} bottom-0`">
            <div class="mx-auto p-6 lg:p-8" :class="`text-${local.footer.textColor}`">
                <div class="grid grid-cols-3 gap-4">
                    <div class="col-span-4 sm:col-span-1">
                        <p class="text-sm">&copy; {{ board.name }}</p>
                        <p class="mt-2 text-sm">Powered by <a rel="noopener" href="#" target="_blank">jobroll</a></p>
                    </div>
                    <div class="col-span-4 sm:col-span-1">
                        <h3 class="font-semibold text-sm uppercase tracking-wide">Categories</h3>
                        <ul class="mt-4 text-sm">
                            <li class="mt-2">
                                <a class="hover:underline"
                                   href="#">Growth hacking</a>
                            </li>
                            <li class="mt-2">
                                <a class="hover:underline"
                                   href="#">Development</a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-span-4 sm:col-span-1">
                        <h3 class="font-semibold text-sm uppercase tracking-wide">Other</h3>
                        <ul class="mt-4 text-sm">
                            <li class="mt-2"><a href="#">About</a></li>
                            <li class="mt-2"><a href="#">Contact</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import EventBus from "@/Jobroll/EventBus";

    export default {
        name: "Preview",
        props: {
            board: Object,
            theme: Object
        },
        mounted() {
            EventBus.$on('theme-updated', (payload) => {
                this.updateTheme(payload)
            })
        },
        data() {
            return {
                local: {
                    body: this.theme.body || {"backgroundColor":"green-50","linkColor":"green-600"},
                    navigation: this.theme.navigation || {"backgroundColor":"green-300"},
                    primaryButton: this.theme.primaryButton || {"backgroundColor":"indigo-600"},
                    logo: this.theme.logo || [],
                    hero: this.theme.hero || {"text":null,"textColor":"gray-900","backgroundColor":"green-200"},
                    footer: this.theme.footer || {"textColor": "gray-400", "backgroundColor": "gray-700"}
                }
            }
        },
        methods: {
            primaryColor() {
                return this.local.body.linkColor.split('-')[0];
            },
            updateTheme(payload) {
                this.local = this.mergeDeep(this.local, payload);
            },
            mergeDeep(...objects) {
                const isObject = obj => obj && typeof obj === 'object';

                return objects.reduce((prev, obj) => {
                    Object.keys(obj).forEach(key => {
                        const pVal = prev[key];
                        const oVal = obj[key];

                        if (Array.isArray(pVal) && Array.isArray(oVal)) {
                            prev[key] = pVal.concat(...oVal);
                        } else if (isObject(pVal) && isObject(oVal)) {
                            prev[key] = this.mergeDeep(pVal, oVal);
                        } else {
                            prev[key] = oVal;
                        }
                    });

                    return prev;
                }, {});
            }
        }
    }
</script>

<style scoped>

</style>
